/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Fragment } from "react";
import { connect } from "react-redux";
import TopNav from "../../TopNavBar";
import { oneSignalSubscription } from "../../../reduxStore/actions/commonAction";

const PublicLayout = props => {
  return (
    <Fragment>
      <TopNav />
      <div className="container-fluid public-layout-container">
        {props.children}
      </div>
    </Fragment>
  );
};

// export default PublicLayout;
const mapStateToProps = props => ({
  userSubscribed: props.commonReducers
});

const mapDispatchToProps = dispatch => ({
  oneSignalSubscription: data => dispatch(oneSignalSubscription(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicLayout);
